import fetch from '@giro/shared-utils/fetch.util';

export default async function getApiOnboardingsService() {
  return fetch(`onboardings`, {
    method: 'GET',
    ms: 'ONBOARDING',
    auth: true,
  });
}
